const getProportion = proportion => (proportion > 0 ? Math.max(0.01, proportion) : 0);

export default getProportion;
